import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Typography from '@classify/react-core-components/Typography';
interface Props {
  children: ReactNode;
}
const CourseTitle = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      pb: 2,
      pt: {
        xs: 2,
        md: 0
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Typography variant="h2" component="h1" sx={t1} id="course-title">{children}</Typography>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default CourseTitle;